export default __webpack_public_path__ + "static/media/transitions_pyramid.f1d5cdbc.svg";